import React, { useEffect, useState } from "react";
import axios from "axios";

function OmniDashboard({ dashboardId }: { dashboardId: number }) {
  const [embedUrl, setEmbedUrl] = useState(null);

  useEffect(() => {
    // Call the Rails auth endpoint to get the signed URL.
    // We pass 'source=omni' and 'src' as the dashboard id.
    axios
      .get(`/auth?source=omni&id=${dashboardId}`)
      .then((response) => {
        // Expect the JSON response to have a field 'url'
        setEmbedUrl(response.data.url);
      })
      .catch((error) => {
        console.error("Error fetching embed URL:", error);
      });
  }, [dashboardId]);

  return (
    <div id="looker-dashboard">
      {embedUrl ? (
        <iframe title="Omni Dashboard" src={embedUrl} />
      ) : (
        <p>Loading dashboard...</p>
      )}
    </div>
  );
}

export default OmniDashboard;
